var $ = (typeof window !== "undefined" ? window['jQuery'] : typeof global !== "undefined" ? global['jQuery'] : null);

function ScrollEvents() {
  $(window).on('vsc-page-ready', this.init.bind(this));
  $(document).on('gform_post_conditional_logic', function() {
    this.updateTargets();
  }.bind(this));
}

ScrollEvents.prototype.init = function() {
  this.updateTargets();

  $(window).on('vsc-page-resized', this.updateTargets.bind(this));

  $(window).add('body > main').off('scroll.vsc-scroll');

  this.$scrollable = $('html').hasClass('css-parallax') ? $('body > main') : $(window);

  this.$scrollable.on('scroll.vsc-scroll', this.onScroll.bind(this));
  this.onScroll({target: document});
};

ScrollEvents.prototype.updateTargets = function() {
  var $targets = $('[data-watch-scroll]');
  var targetMap = {};
  var resetTargets = [];

  $targets.each(function() {
    var el = this;
    var $el = $(el);
    var top = $el.offset().top;
    var bottom = top + $el.outerHeight();

    targetMap[top] = targetMap[top] || [];

    targetMap[top].push(el);
  });

  this.map = targetMap;
  this.$resetTargets = $('[data-reset-scroll]');
};

ScrollEvents.prototype.onScroll = function(event) {
  var scrollTop = (event.target == document) ? window.pageYOffset : event.target.scrollTop;
  var scrollBottom = scrollTop + window.innerHeight;

  if(scrollTop == 0) {
    this.$resetTargets.filter('[data-watch-scroll="in"]')
      .trigger('scroll-reset.vsc-scroll')
      .attr('data-watch-scroll', '');
  }

  for(var targetY in this.map) {
    if(scrollBottom > targetY) {
      var targets = this.map[targetY];

      targets.forEach(function(targetEl, i) {
        if(targetEl.getAttribute('data-watch-scroll') !== 'in') {
          setTimeout(function() {
            targetEl.setAttribute('data-watch-scroll', 'in');
            $(targetEl).trigger('scroll-in.vsc-scroll');
          }, 50 * i);
        }
      });
    }
  }

  if(scrollTop >= window.innerHeight && !$('body').hasClass('show-back-to-top')) {
    $('body').addClass('show-back-to-top');
  } else if(scrollTop <= window.innerHeight && $('body').hasClass('show-back-to-top')) {
    $('body').removeClass('show-back-to-top');
  }
}

module.exports = ScrollEvents;
